// extracted by mini-css-extract-plugin
export default {"container":"not-allowed-screen_container__NGR6a","card":"not-allowed-screen_card__qCBQ8","text":"not-allowed-screen_text__i-S6B"};